/**
 * Permissions 管理
 * 可管理
 * 用户信息
 * token
 * 用户权限
 *  如果只是 临时保存同一窗口(或标签页)的用户数据
 *  则使用 sessionStorage 存储 token userinfo
 *  数据请求规则 获取 token优先级  sessionStorage > localStorage
 */

const state = {
	token: null,
	userinfo: {},
	permissions: {},
	isUpdate: false, // 控制是否更新用户信息
	mid: null, // 用户来源
};
/* mutations 示例
      TOGGLE_SIDEBAR: state => {
      },
      CLOSE_SIDEBAR: (state, withoutAnimation) => {
      },
      TOGGLE_DEVICE: (state, device) => {
      },
      SYNCHRONOUS: (state, parmas)=>{} 
  */
const mutations = {
	/**
	 * 添加用户信息
	 * @param {Object} state
	 * @param {Object} userinfo 用户信息
	 */
	ADD_USERINFO: (state, userinfo) => {
		state.userinfo = userinfo;
	},
	/**
	 * 添加临时会话信息
	 * @param {Object} state
	 * @param {String} token
	 */
	ADD_TOKEN: (state, token) => {
		state.token = token;
	},
	/**
	 * 清除 用户信息
	 * @param {Object} state
	 */
	CLEAR_USERINFO: (state) => {
		state.userinfo = {};
	},
	/**
	 * 清除临时会话信息
	 * @param {Object} state
	 */
	CLEAR_TOKEN: (state) => {
		state.token = null;
	},
	// 通知各需要用到用户信息的组件是否需要更新数据
	ISUPDATE: (state, value) => {
		state.isUpdate = value;
	},
	// 存储用户来源
	SAVE_MID: (state, value) => {
		state.mid = value;
	},
};
/* actions  示例
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    }, 
  */
const actions = {
	/**
	 * 添加用户信息
	 * @param {Object} param-commit
	 * @param {Object} userinfo
	 */
	addUserinfo({ commit }, userinfo) {
		commit('ADD_USERINFO', userinfo);
	},
	/**
	 * 添加临时会话信息
	 * @param {*} param-commit
	 * @param {*} token
	 */
	addToken({ commit }, token) {
		commit('ADD_TOKEN', token);
	},
	/**
	 * 清除
	 * @param {Object} param-dispatch
	 */
	clear({ dispatch }) {
		dispatch('clearUserinfo');
		dispatch('clearToken');
	},
	/**
	 * 清除用户信息
	 * @param {Object} param-commit
	 */
	clearUserinfo({ commit }) {
		commit('CLEAR_USERINFO');
	},
	/**
	 * 清除临时会话信息
	 * @param {Object} param-commit
	 */
	clearToken({ commit }) {
		commit('CLEAR_TOKEN');
	},
	// 通知各需要用到用户信息的组件是否需要更新数据
	isUpdate({ commit }, value) {
		commit('ISUPDATE', value);
	},
	// 存储用户来源
	saveMid({ commit }, value) {
		commit('SAVE_MID', value);
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
};
